import { createAction } from 'typesafe-actions';
import { PRODUCT_IN_SET_VIEW } from 'features/related-products';
import {
  getPrimaryPriceCb,
  getProductBelongFromSource,
  getProductPriceCategoryUtil,
} from 'features/product-info';
import { put, select, call, takeEvery } from 'redux-saga/effects';
import { getStocksInStores, StoreStockData } from 'features/goods-supply';
import {
  selectProductId,
  selectReviewsTotalCount,
  selectReviewsTotalScore,
  selectVariantsRatingAvg,
  selectVariantsReviewsTotal,
} from '../selectors';
import { GaProductBelong } from '../types';

/**
 * Событие должно срабатывать при попадании каждого товара во viewport.
 * @see {@link http://10.203.56.19:8000/assignment/group/cd1bece5e52a4ebf86dd77b514e8ac6f/view Добавит аналитику для Показ товаров в составе комплекта (комплекты)}
 */

export const gaViewInSet = createAction('GA:impressions')<{
  elementType: 'product';
  elementBlock: 'komplektyDetail / products';
  productName: string;
  productId: string;
  productPrice: string;
  productBelong: GaProductBelong;
  productTag: string;
  productDiscount: string | null;
  productPrevPrice: string | null;
  productPosition: string;
  komplektyId: string;
  avgRating: string;
  reviews: string;
  variantsReviewsTotal: string;
  variantsRatingAvg: string;
}>();

export function* putGaViewInSet(action: ReturnType<typeof PRODUCT_IN_SET_VIEW>) {
  const { productInfo, index } = action.payload;

  const { productId, source, price, displayedName } = productInfo;

  const stocks: StoreStockData[] = yield select(getStocksInStores);

  const primaryPrice = getPrimaryPriceCb(price);

  const productBelong = getProductBelongFromSource(source);

  const komplektyId: string = yield call(selectProductId);

  const productTag = getProductPriceCategoryUtil(productInfo, primaryPrice, stocks);

  yield put(
    gaViewInSet({
      elementType: 'product',
      elementBlock: 'komplektyDetail / products',
      productName: displayedName ?? '',
      productId,
      productPrice: price?.main_price.toString() ?? '',
      productBelong,
      productTag,
      productDiscount: primaryPrice.discountPercent?.toString() ?? null,
      productPrevPrice: primaryPrice.prevPrice?.toString() ?? null,
      productPosition: index.toString(),
      komplektyId,
      avgRating: yield call(selectReviewsTotalScore),
      reviews: yield call(selectReviewsTotalCount),
      variantsReviewsTotal: yield call(selectVariantsReviewsTotal),
      variantsRatingAvg: yield call(selectVariantsRatingAvg),
    }),
  );
}

export function* runViewInSetDetector() {
  yield takeEvery(PRODUCT_IN_SET_VIEW, putGaViewInSet);
}
